function getHeaderValue(
  headers: Record<string, string> | undefined,
  headerName: string,
  caseInsensitive = true
): string | undefined {
  if (!headers) return undefined

  if (caseInsensitive) {
    const normalizedName = headerName.toLowerCase()
    const key = Object.keys(headers).find(k => k.toLowerCase() === normalizedName)
    return key ? headers[key] : undefined
  }
  return headers[headerName]
}

export default getHeaderValue
